import '@/assets/scss/style.scss';
import helpers from '@/assets/js/helpers';
import sidebar from '@/assets/js/sidebar';

require('es6-promise').polyfill();

window.$ = window.jQuery;
window.helpers = helpers;

for (const key in helpers) {
  window[key] = helpers[key];
}

const init = () => {
  sidebar();

  const $htmlAndBody = $('html, body');
  $htmlAndBody.addClass('loaded');


  $(document).ready(function() {
    $.expr[":"].external = function(a) {
      var linkhn = a.hostname.split('.').reverse();
      var linkHref = linkhn[1] + "." + linkhn[0];
      var domainhn = window.location.hostname.split('.').reverse();
      var domainHref = domainhn[1] + "." + domainhn[0];
      return !a.href.match(/^mailto\:/) && !a.href.match(/^tel\:/) && linkHref !== domainHref && a.hostname !== '/' && a.hostname !== '';
    };

    $("a:external").addClass("ext_link");

    const contactUsLink  = $('a[href="http://www.seqirus.com.au/contact"]');
    const noExt  = $('.no_ext');
    contactUsLink.removeClass('ext_link');
    noExt.removeClass('ext_link');

    const overlay = $('.exit-modal__overlay');
    const external = $('.exit-modal__overlay .okay');
    const cancel = $('.exit-modal__overlay .cancel');

    cancel.on('click', function() {
      $('.exit-modal__overlay').removeClass('exit-modal__overlay--open');
      external.attr('href', null);
    })

    $('a.ext_link').click(function(event) {
      event.preventDefault();
      $('.exit-modal__overlay').addClass('exit-modal__overlay--open');
      var url = $(this).attr('href');
      external.attr('href', url);
    });

    $('.mobile-hamburger-menu').on('click', function() {
      $('.site-header').toggleClass('site-header--mobile-menu-clicked')

      if ($('.site-header').hasClass('site-header--mobile-menu-clicked')) {
        if ($('body').hasClass('logged-in')) {
          $('.mobile-hamburger-menu img').attr('src', '/wp-content/themes/qfever/webpack/static/images/hamburger-cross.png');
        } else {
          $('.mobile-hamburger-menu img').attr('src', '/wp-content/themes/qfever/webpack/static/images/hamburger-cross--consumer.png');
        }

      } else {
        if ($('body').hasClass('logged-in')) {
          $('.mobile-hamburger-menu img').attr('src', '/wp-content/themes/qfever/webpack/static/images/hamburger-icon.png');
        } else {
          $('.mobile-hamburger-menu img').attr('src', '/wp-content/themes/qfever/webpack/static/images/hamburger-orange.png');
        }
      }
    })

    const hamburger = $('.hamburger-menu');

    hamburger.on('click', function (event) {
      event.stopPropagation()
      hamburger.toggleClass('hamburger-menu--clicked');
    })


    $(window).on('click', function() {
      hamburger.removeClass('hamburger-menu--clicked');
    });

    $(window).on('resize', function() {
      console.log('resize!')
      if (window.innerWidth > 767) {
        console.log('triggered')
        $('#masthead').removeClass('site-header--mobile-menu-clicked');
        if ($('body').hasClass('logged-in')) {
          $('.mobile-hamburger-menu img').attr('src', '/wp-content/themes/qfever/webpack/static/images/hamburger-icon.png');
        } else {
          $('.mobile-hamburger-menu img').attr('src', '/wp-content/themes/qfever/webpack/static/images/hamburger-orange.png');
        }
      }
    })



  });
};

window.onload = init;



// WEBPACK FOOTER //
// ./src/main.js